<template>
    <div>
        <SidePanel
            :visible="!!(guardianStore && guardianStore?.isPanelVisible)"
            :title="panelTitle"
            :no-scroll="!guardianStore || guardianStore.activeTab === 'THREAD'"
            :body-style="
                guardianStore &&
                guardianStore.activeTab === 'NEW' &&
                this.$windowHeight > 772
                    ? 'overflow: visible'
                    : ''
            "
            @close="closePanel"
        >
            <GuardianThreadList
                v-if="guardianStore.activeTab === 'HISTORY'"
                :guardian="guardianStore.currentGuardian"
            />

            <GuardianThread
                ref="guardianThreadTab"
                v-else-if="guardianStore.activeTab === 'THREAD'"
                :thread-id="activeThreadId"
                :guardian="guardianStore.currentGuardian"
            />

            <NewGuardianChat
                v-else-if="guardianStore.activeTab === 'NEW'"
                :guardian="guardianStore.currentGuardian"
                :show-history-btn="false"
            />

            <template #footer>
                <PanelFooter
                    :show-choose-guardian="$userStore.companyHasPerm('alpha:access')"
                    @choose-guardian="handleChooseGuardian"
                    @open-history="guardianStore.openHistory(guardianStore.currentGuardian)"
                />
            </template>
        </SidePanel>

        <!-- Modal outside SidePanel so it's not affected by panel visibility -->
        <GuardianSelectionModal
            :visible="isGuardianModalVisible"
            @close="closeGuardianModal"
        />
    </div>
</template>

<script>
import GuardianThread from '@/components/guardians/GuardianThread.vue';
import NewGuardianChat from '@/components/guardians/NewGuardianChat.vue';
import GuardianThreadList from '@/components/guardians/GuardianThreadList.vue';
import GuardianSelectionModal from '@/components/guardians/GuardianSelectionModal.vue';
import SidePanel from '@/components/SidePanel.vue';
import PanelFooter from '@/components/PanelFooter.vue';
import { useGuardianStore } from '@/stores/guardian';

export default {
    name: 'GuardianPanel',
    components: {
        GuardianThread,
        NewGuardianChat,
        GuardianThreadList,
        GuardianSelectionModal,
        SidePanel,
        PanelFooter,
    },
    data() {
        return {
            guardianStore: null,
            isGuardianModalVisible: false,
        };
    },
    computed: {
        activeThreadId() {
            return this.guardianStore?.threadId || null;
        },
        panelTitle() {
            return 'AI Assistance';
        },
    },
    mounted() {
        this.guardianStore = useGuardianStore();
    },
    methods: {
        closePanel() {
            this.guardianStore.closePanel();
        },
        handleChooseGuardian() {
            // Show guardian selection modal
            this.isGuardianModalVisible = true;
        },
        closeGuardianModal() {
            this.isGuardianModalVisible = false;
        },
    },
};
</script>

<style scoped>
/* No component-specific styles needed - footer styles are in PanelFooter.vue */
</style>

